import { useRoute } from "@react-navigation/native";
import { useEffect } from "react";
import { Image, StyleSheet, Text, TouchableHighlight, View } from "react-native";
import { appConfigStore } from "../../app/stores/AppConfig";
import { navigationStore } from "../../app/stores/Navigation";
import { AppLogo as AppLogoFallback } from "../../config/constants";
import { useStoreConfig } from "../../contexts/StoreConfigContext";

export const ContactUs = () => {
	const darkMode = appConfigStore((state) => state.darkMode);
	const { config } = useStoreConfig();
	
	// Check if logo is URL, data URL, or local asset
	const isUrl = config.appLogo.startsWith('http://') || config.appLogo.startsWith('https://') || config.appLogo.startsWith('data:');
	const heroImage = isUrl ? { uri: config.appLogo } : require(`../../assets/${AppLogoFallback}`)
	const updateSplashLoaded = navigationStore((state) => state.updateSplashLoaded);

	const route = useRoute();
	useEffect(() => {
		updateSplashLoaded(true);
	}, []);

	return (
		<View
			style={ { ...styles.background, ...{ backgroundColor: darkMode ? "#232323" : "#f7f7f7" } } }
		>
			<TouchableHighlight underlayColor={ "transparent" }>
				<Image
					style={ styles.image }
					source={ heroImage }
				/>
			</TouchableHighlight>
			<Text style={ { ...styles.screenName, ...{ color: darkMode ? "white" : "black" } } }>
				Contact Us
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	background: {
		flex: 1,
		justifyContent: "center",
	},
	image: {
		marginTop: 20,
		width: 50,
		aspectRatio: 1,
		borderRadius: "50%",
		resizeMode: "contain",
		alignSelf: "center",
	},
	screenName: {
		margin: 16,
		alignSelf: "center",
		fontWeight: "500",
	},
});
